import { NO_USER, GUEST_LOGGED_IN_USER, LOGGED_IN_USER } from "../constents/app";

export const user = {
  namespaced: true,
  state: () => ({
    location: "Romania",
    loggedInUserType: NO_USER
    //currency: "USD",
  }),
  mutations: {
    updateLoggedInUserType(state, type) {
      state.loggedInUserType = type;
    },
  },
  actions: {
    updateLoggedInUserType({ commit }, type) {
      commit("updateLoggedInUserType", type);
    },
  },
  getters: {
    LoggedInUserType: (state) => {
      return state.loggedInUserType;
    },
    isLoggedInUser: (state, getters) => {
      return getters.LoggedInUserType === LOGGED_IN_USER;
    },
    isGuestUser: (state, getters) => {
      return getters.LoggedInUserType === GUEST_LOGGED_IN_USER;
    }
  },
};
